import { style } from '@vanilla-extract/css'
import check from './check.svg'

const label = style({
  backgroundColor: 'white',
  border: '1px solid transparent',
  borderRadius: '16px',
  padding: '16px',
  width: '100%',
  userSelect: 'none',
  selectors: {
    '&:has(input:checked)': {
      border: '1px solid #E46327',
    },
  },
})

const thumbnail = style({
  width: '72px',
  height: 'auto',
  borderRadius: '8px',
})

const heading = style({
  fontSize: '18px',
  fontWeight: '700',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  wordBreak: 'keep-all',
})

const description = style({
  fontSize: '15px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
})

const price = style({
  fontFamily: 'Noto Sans Variable, sans-serif',
  fontSize: '14px',
  fontWeight: '700',
  lineHeight: '1.5',
  color: '#F43E3B',
})

const comparedTo = style({
  fontFamily: 'Noto Sans Variable, sans-serif',
  fontSize: '13px',
  lineHeight: '1.5',
  color: '#828282',
})

const mazzoIncluded = style({
  fontSize: '13px',
  fontWeight: '700',
})

const button = style({
  pointerEvents: 'none',
})

const diff = style({
  fontFamily: 'Noto Sans Variable, sans-serif',
  fontSize: '12px',
  fontWeight: '700',
  lineHeight: '1.5',
  color: 'white',
  padding: '2px 4px',
  borderRadius: '4px',
  backgroundColor: '#F43E3B',
})

const checkbox = style({
  display: 'none',
})

export const styles = {
  label,
  thumbnail,
  heading,
  description,
  price,
  comparedTo,
  diff,
  mazzoIncluded,
  button,
  checkbox,
}
